import React from "react";

class StopWatch extends React.Component {
  toggle() {
    this.setState({
      time: !this.state.time,
    });
  }

  setTime(x) {
    this.setState({
      runTime: x,
    });
  }

  showTime() {
    return `0${parseInt(this.state.runTime / 60)}:${(
      "000000" + (this.state.runTime % 60).toString()
    ).slice(-2)}`;
  }

  render() {
    const parent = this.props.measur;
    return (
      <div className="stopwatch">
        <div className="time">{this.showTime.call(parent)}</div>
        <span className="time_sel" onClick={this.toggle.bind(parent)}>
          <div
            className="time_list"
            style={{ display: parent.state.time ? "block" : "none" }}
          >
            <ul>
              <li onClick={() => this.setTime.call(parent, 120)}>02:00</li>
              <li onClick={() => this.setTime.call(parent, 60)}>01:00</li>
              <li onClick={() => this.setTime.call(parent, 30)}>00:30</li>
              <li onClick={() => this.setTime.call(parent, 15)}>00:15</li>
            </ul>
          </div>
        </span>
      </div>
    );
  }
}

export default StopWatch;
